"use client";

import { Activity, Brain, Compass, Flame, ChartLine as LineChart, Radar } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Mountingmethodstechnical() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const capabilities = [{
    number: "01",
    title: "Phenolic Legend Plates",
    description: "Industrial-grade phenolic engraving for harsh environments. UV-stable, chemical-resistant, and compliant with all major electrical standards.",
    Icon: LineChart
  }, {
    number: "02",
    title: "Stainless Steel Marking",
    description: "Precision laser marking on 304 and 316 stainless steel. Permanent identification for high-heat and corrosive industrial applications.",
    Icon: Brain
  }, {
    number: "03",
    title: "Arc Flash Labeling",
    description: "Custom-engineered arc flash warning labels. Compliant with NFPA 70E requirements for safety and facility identification.",
    Icon: Radar
  }, {
    number: "04",
    title: "Asset and Valve Tags",
    description: "Durable metal and plastic tags for facility management. Clear, permanent identification for valves, equipment, and critical infrastructure.",
    Icon: Compass
  }, {
    number: "05",
    title: "Direct Part Marking",
    description: "High-contrast laser marking directly onto components. Traceability solutions for manufacturing, aerospace, and defense sectors.",
    Icon: Activity
  }, {
    number: "06",
    title: "MIL-SPEC Identification",
    description: "Certified engraving services meeting rigorous military specifications. Reliable, compliant, and built for extreme operational conditions.",
    Icon: Flame
  }];
  return;
}